<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称" :help="null">
              <global-select
                v-decorator="['planName', { rules: [{ required: true }] }]"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2 }"
                :allowClear="false"
                @change="planNameChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划版本" :help="null">
              <global-select
                v-decorator="['planVersion', { rules: [{ required: true }] }]"
                selectType="selectAssembleSearch"
                requestApi="/scp/scpMrpPlans/planVersionBox"
                :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne', thirdLabelText: '最新版本' }"
                :setParams="{ dataType: 2, planName: form.getFieldsValue().planName }"
                searchParam="planVersion"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                v-decorator="['organizationCode']"
                requestApi="/scp/scpMrpPlans/planOrganizationBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion }"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="计划员">
              <global-select
                v-decorator="['plannerCodeList']"
                selectType="selectMultiple"
                requestApi="/system/user/allJobCodeName"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料编码" :help="null">
              <global-select
                v-decorator="['itemIdList', { rules: [{ required: true }] }]"
                selectType="selectMultipleSearch"
                :focusGet="true"
                :selectData="itemIdListData"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpMrpSystemItems/planItemsBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion, organizationCode: form.getFieldsValue().organizationCode }"
                searchParam="label"
                :allowClear="false"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料类别">
              <a-tree-select
                v-decorator="['categoryIdList']"
                :dropdown-style="{
                  maxHeight: '50vh'
                }"
                :tree-data="treeData"
                :max-tag-count="1"
                :replaceFields="{children: 'child', title: 'name', key: 'segment', value: 'id' }"
                tree-checkable
                allow-clear
                tree-node-filter-prop="title"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="供应或需求">
              <global-select
                v-decorator="['demandOrSupply']"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_MRP_DEMAND_OR_SUPPLY' }"
                @change="demandOrSupplyChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced && !form.getFieldsValue().demandOrSupply">
            <a-form-item label="订单类型">
              <global-select
                v-decorator="['orderTypeList']"
                selectType="selectMultiple"
                :selectData="orderTypeListData"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced && form.getFieldsValue().demandOrSupply === 'DEMAND'">
            <a-form-item label="订单类型">
              <global-select
                v-decorator="['orderTypeList']"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_MRP_DEMAND_TYPE' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced && form.getFieldsValue().demandOrSupply === 'SUPPLY'">
            <a-form-item label="订单类型">
              <global-select
                v-decorator="['orderTypeList']"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_MRP_SUPPLY_TYPE' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="建议到期日范围" :labelCol="{ style: { width: '100px' } }">
              <a-tooltip>
                <template slot="title">{{ $timeText(form.getFieldsValue().newDueDate, 'YYYY-MM-DD') }}</template>
                <a-range-picker v-decorator="['newDueDate']" valueFormat="YYYY-MM-DD" allowClear />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport" v-hasPermi="['scp:scpMrpSupplies:exportSupplyDemandList']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="serialNumber"
          :scroll="{ fixScreen: true, x: 4100 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.SUPPLY_DEMAND_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a @click="goNextPage(record)">物料</a>
                <a class="ml10" @click="$refs.retrospectList.show(record)">追溯</a>
              </span>
              <span v-else-if="item.type === 'switch'">
                <a-switch :disabled="true" :checked="record[item.dataIndex] === 'Y'" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <retrospect-list ref="retrospectList" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiScpMrpSuppliesSupplyDemandList, apiScpMrpCategoryCodeCategoryBox } from '@/api/scp/mrp-result-query/supply-demand'
import { generateLsTableResData } from '@/utils/util.js';
import RetrospectList from './components/retrospect-list'

export default {
  // eslint-disable-next-line
  name: 'Supply-demand', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    RetrospectList
  },
  data () {
    return {
       // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpSuppliesSupplyDemandList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      form: this.$form.createForm(this),
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '组织',
          dataIndex: 'organizationName',
          align: 'center',
          width: 140,
          ellipsis: true,
          stickyFixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 140,
          ellipsis: true,
          stickyFixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '建议到期日',
          dataIndex: 'newDueDate',
          scopedSlots: { customRender: 'newDueDate' },
          align: 'center',
          width: 170,
          type: "text"
        },
        {
          title: '数量',
          dataIndex: 'newOrderQuantity',
          align: 'center'
        },
        {
          title: '建议入库日',
          dataIndex: 'newScheduleDate',
          scopedSlots: { customRender: 'newScheduleDate' },
          align: 'center',
          width: 170,
          type: "text"
        },
        {
          title: '建议到货日',
          dataIndex: 'newDockDate',
          scopedSlots: { customRender: 'newDockDate' },
          align: 'center',
          width: 170,
          type: "text"
        },
        {
          title: '建议起始日',
          dataIndex: 'newWipStartDate',
          scopedSlots: { customRender: 'newWipStartDate' },
          align: 'center',
          width: 170,
          type: "text"
        },
        {
          title: '订单号',
          dataIndex: 'orderNumber',
          align: 'center',
          width: 170,
          ellipsis: true
        },
        {
          title: '活动',
          dataIndex: 'statusName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '固定',
          dataIndex: 'firmPlannedType',
          scopedSlots: { customRender: 'firmPlannedType' },
          align: 'center',
          type: "switch"
        },
        {
          title: '使用装配件',
          dataIndex: 'useItemCode',
          align: 'center',
          width: 170,
          ellipsis: true
        },
        {
          title: '签价单号',
          dataIndex: 'alternateBomDesignator',
          align: 'center',
          width: 170,
          ellipsis: true
        },
        {
          title: '集采类型',
          dataIndex: 'centralizedPurchasingTypeName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '来源组织',
          dataIndex: 'sourceOrganizationName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '来源供应商',
          dataIndex: 'sourceSupplierName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '原到货日',
          dataIndex: 'originalDockDate',
          scopedSlots: { customRender: 'originalDockDate' },
          align: 'center',
          width: 170,
          type: "text"
        },
        {
          title: '原起始日',
          dataIndex: 'originalOrderDate',
          scopedSlots: { customRender: 'originalOrderDate' },
          align: 'center',
          width: 170,
          type: "text"
        },
        {
          title: '计划员',
          dataIndex: 'realName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '一级分类',
          dataIndex: 'name1',
          align: 'center',
          ellipsis: true
        },
        {
          title: '二级分类',
          dataIndex: 'name2',
          align: 'center',
          ellipsis: true
        },
        {
          title: '三级分类',
          dataIndex: 'name3',
          align: 'center',
          ellipsis: true
        },
        {
          title: '压缩天数',
          dataIndex: 'scheduleCompressDays',
          align: 'center'
        },
        {
          title: '不可净得量',
          dataIndex: 'nonNettableQty',
          align: 'center'
        },
        {
          title: '色差标识',
          dataIndex: 'invColorDifferFlag',
          scopedSlots: { customRender: 'invColorDifferFlag' },
          align: 'center',
          type: "switch"
        },
        {
          title: '参与MRP标识',
          dataIndex: 'wipNettingFlag',
          scopedSlots: { customRender: 'wipNettingFlag' },
          align: 'center',
          type: "switch"
        },
        {
          title: '计划名称',
          dataIndex: 'planName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '计划版本',
          dataIndex: 'planVersion',
          align: 'center',
          ellipsis: true
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      treeData: [], // 物料类别
      orderTypeListData: [], // 订单类型
      itemIdListData: [] // 物料编码
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  watch: {
    // 菜单和查询物料两个入口
    $route (to, from) {
      if (to.name !== "Supply-demand") {
        return
      }
      if (Object.keys(this.$route.query).length > 0) {
        this.goNextHandle()
      } else {
        this.$nextTick(() => {
          this.form.resetFields()
        })
      }
    }
  },
  created () {
    // 从查询物料页面跳转过来，带过来的数据自动填充
    if (Object.keys(this.$route.query).length > 0) {
      this.goNextHandle()
    }
    this.getOrderTypeListData()
  },
  mounted () {
    this.getSearchAllScheme()
  },
  methods: {
    // 计划名称变化，清空历史选择的计划版本
    planNameChange() {
      this.form.setFieldsValue({ planVersion: '' })
    },
    goNextHandle () {
      const obj = JSON.parse(this.$route.query.data)
      const arr = []
      const arr2 = []
      const arr3 = [{ realValue: "", label: "" }]
      obj.plannerCode && arr.push(obj.plannerCode)
      obj.itemId && arr2.push(obj.itemId)
      obj.plannerCodeList = arr
      obj.itemIdList = arr2
      arr3[0].realValue = obj.itemId
      arr3[0].label = obj.itemCode
      this.itemIdListData = arr3
      this.$nextTick(() => {
        this.form.setFieldsValue({
          planName: obj.planName,
          planVersion: obj.planVersion,
          organizationCode: obj.organizationCode,
          plannerCodeList: obj.plannerCodeList,
          itemIdList: obj.itemIdList
        })
        this.onSearch()
      })
    },
    goNextPage (record) {
      this.$router.push({ name: "Matter-source", query: { data: JSON.stringify(record) } })
    },
    // 供应或需求 下拉框
    demandOrSupplyChange (val) {
      this.form.setFieldsValue({
        orderTypeList: undefined
      })
    },
    // 物料类别-下拉框数据
    getSearchAllScheme () {
      apiScpMrpCategoryCodeCategoryBox({ parameterCode: "SCP_ITEM_CATEGORY", parameterLevelCode: "GLOBAL" }).then(res => {
        if (res.data && res.data.length > 0) {
          this.treeData = res.data
        }
      })
    },
    // 表单搜索
    onSearch () {
      if (!this.form.getFieldsValue().planName) {
        this.$message.warning('计划名称不能为空')
        return;
      }
      if (!this.form.getFieldsValue().planVersion) {
        this.$message.warning('计划版本不能为空')
        return;
      }
      if (!this.form.getFieldsValue().itemIdList) {
        this.$message.warning('物料编码不能为空')
        return;
      }
      const params = this.form.getFieldsValue()
      params.startNewDueDate = params.newDueDate && params.newDueDate[0] ? `${params.newDueDate[0]} 00:00:00` : ""
      params.endNewDueDate = params.newDueDate && params.newDueDate[1] ? `${params.newDueDate[1]} 23:59:59` : ""
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('scp/scpMrpSupplies/exportSupplyDemandList', {
        ...this.form.getFieldsValue()
      }, `供应需求_${new Date().getTime()}.xlsx`)
    },
    // 订单类型
    getOrderTypeListData () {
      Promise.all([
        new Promise((resolve, reject) => {
          this.getLookupList('SCP_MRP_DEMAND_TYPE', '', resolve)
        }),
        new Promise((resolve, reject) => {
          this.getLookupList('SCP_MRP_SUPPLY_TYPE', '', resolve)
        })
      ]).then(results => {
        this.orderTypeListData = results[0].concat(results[1])
      })
    },
    getLookupList (type, arr, resolve) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (type === "SCP_MRP_DEMAND_TYPE" || type === "SCP_MRP_SUPPLY_TYPE") {
          resolve(response.rows)
          return
        }
        this[arr] = response.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
</style>
